import { render, staticRenderFns } from "./relatorioVerbasDiversas.vue?vue&type=template&id=f67548e4&scoped=true&"
import script from "./relatorioVerbasDiversas.vue?vue&type=script&lang=js&"
export * from "./relatorioVerbasDiversas.vue?vue&type=script&lang=js&"
import style0 from "./relatorioVerbasDiversas.vue?vue&type=style&index=0&id=f67548e4&scoped=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67548e4",
  null
  
)

export default component.exports